import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Maximize2 } from 'lucide-react';
import { projectFilters, projects, type Project } from '../data/site';
import { ProjectLightbox } from './ProjectLightbox';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function Work() {
  const [filter, setFilter] = useState<(typeof projectFilters)[number]>('All');
  const [active, setActive] = useState<Project | null>(null);
  const visible = filter === 'All' ? projects : projects.filter(p => p.type === filter);
  return <section id="work" className="w-full bg-white py-24 lg:py-32" data-id="element-413" data-mp="2mruaveey0fk9">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8" data-id="element-414" data-mp="2mtp034x8ytu5">
        <Reveal data-id="element-415" data-mp="2rrqdpabwm0y8">
          <SectionHeading label="Portfolio" title="Our work" description="See the craftsmanship behind every Pure Build Construction project." data-id="element-416" data-mp="2rs8kv203tzkx" />
        </Reveal>

        <Reveal delay={0.1} data-id="element-417" data-mp="6ylna4gqjo8v">
          <div role="tablist" aria-label="Filter projects" className="no-scrollbar mt-12 flex gap-2 overflow-x-auto border-b border-mist-200 pb-px" data-id="element-418" data-mp="1n2vi2ix11zoj">
            {projectFilters.map(f => <button key={f} type="button" role="tab" aria-selected={filter === f} onClick={() => setFilter(f)} className={['relative shrink-0 px-5 py-4 text-[11px] font-bold uppercase tracking-[0.16em] transition', filter === f ? 'text-navy' : 'text-mist-400 hover:text-navy'].join(' ')} data-id="element-419" data-mp="1d3o9sa55gv8a">
                {f}
                {filter === f && <motion.span layoutId="filter-underline" className="absolute inset-x-0 -bottom-px block h-[3px] bg-brand-500" data-id="element-420" data-mp="pgog7gs3ylfv" />}
              </button>)}
          </div>
        </Reveal>

        <motion.div layout className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-421" data-mp="5t1zp5ol1k9k">
          <AnimatePresence mode="popLayout" data-id="element-422" data-mp="asxx2m2rydg5">
            {visible.map((p, i) => <motion.button key={p.id} layout type="button" onClick={() => setActive(p)} aria-label={`Open ${p.name} project`} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.45,
            delay: i % 3 * 0.06
          }} className="group relative block overflow-hidden bg-navy-900 text-left" data-id="element-423" data-mp="3syaui119d8pf" data-mpi={i}>
                <img src={p.image} alt={`${p.name} — ${p.service} in ${p.location}`} className="h-72 w-full object-cover transition duration-[900ms] ease-out group-hover:scale-[1.07]" data-id="element-424" data-mp="kpsrotvxftp5" />
                <span className="absolute inset-0 bg-navy-900/0 transition duration-500 group-hover:bg-navy-900/70" aria-hidden="true" data-id="element-425" data-mp="1d8q1ltk8f9uc" />
                <span className="absolute right-4 top-4 inline-flex h-10 w-10 translate-y-2 items-center justify-center bg-brand-500 text-white opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100" data-id="element-426" data-mp="1ii0t7hgu706w">
                  <Maximize2 className="h-4 w-4" aria-hidden="true" data-id="element-427" data-mp="13mb4hbk9o8yh" />
                </span>
                <span className="absolute inset-x-0 bottom-0 block translate-y-3 p-6 opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100" data-id="element-428" data-mp="zlitacru3tzk">
                  <span className="mb-3 block h-px w-10 bg-brand-500" aria-hidden="true" data-id="element-429" data-mp="1dinwm505yer4" />
                  <span className="block text-[10px] font-semibold uppercase tracking-[0.22em] text-brand-400" data-id="element-430" data-mp="18o0h2vn50uoo">
                    {p.service}
                  </span>
                  <span className="mt-1.5 block font-heading text-xl font-extrabold uppercase leading-tight tracking-tight text-white" data-id="element-431" data-mp="2k0b0wcjwlggz">
                    {p.name}
                  </span>
                  <span className="mt-1 block text-sm text-white/55" data-id="element-432" data-mp="yk4xqr0les1u">{p.location}</span>
                </span>
              </motion.button>)}
          </AnimatePresence>
        </motion.div>
      </div>

      <ProjectLightbox project={active} onClose={() => setActive(null)} data-id="element-433" data-mp="17kjjtsldsb6e" />
    </section>;
}